import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

// Renders the company (commercial) CIBIL summary from account.cibilSummary.
// Shape: { sumOfSanctionedAmount, sumOfOutstandingAmount, cibilLoanDetails: [ ... ] }
const CompanyCibilUI = ({ context, account }) => {
  const cibil = account && account.cibilSummary
  const details = (cibil && cibil.cibilLoanDetails) || []

  const openFullReport = () => {
    const accountId = account && account.accountId
    if (!accountId) return
    RestApiUtils.get(context,
      `/api/su/accounts/${accountId}/cibil/report/company`,
      (response) => {
        if (response && (!response.errorList || response.errorList.length === 0)
          && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank')
        } else {
          const msg = (response && response.errorList && response.errorList[0]
            && (response.errorList[0].message || response.errorList[0])) || 'Report not available'
          alert('CIBIL report: ' + msg)
        }
      },
      null,
      null
    )
  }

  return (
    <CardUI className='g_m_top_100' title='Company CIBIL'>
      {
        !cibil &&
        <div className='g_m_top_50 g_muted'>No CIBIL summary available for this company.</div>
      }
      {
        cibil &&
        <div className='g_m_top_50'>
          <div className='g_m_bottom_50'>
            <a href='#' onClick={(e) => { e.preventDefault(); openFullReport() }}>View full CIBIL report</a>
          </div>
          <div className='g_flex_h'>
            <span className='left'>Total sanctioned</span>
            <span>{cibil.sumOfSanctionedAmount || '-'}</span>
          </div>
          <div className='g_flex_h'>
            <span className='left'>Total outstanding</span>
            <span>{cibil.sumOfOutstandingAmount || '-'}</span>
          </div>

          {
            details.length === 0 &&
            <div className='g_m_top_50 g_muted'>No loan facilities reported.</div>
          }
          {
            details.length > 0 &&
            <table className='g_table_3 g_m_top_50'>
              <thead>
                <tr style={{ textAlign: 'left' }}>
                  <th>Institution</th>
                  <th>Type</th>
                  <th>Sanction date</th>
                  <th>Sanctioned</th>
                  <th>Outstanding</th>
                  <th>Security</th>
                  <th>Asset class</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  details.map((d, i) =>
                    <tr key={i}>
                      <td>{d.financialInstitution}</td>
                      <td>{d.loanType}</td>
                      <td>{d.dateOfSanction}</td>
                      <td>{d.sanctionedAmount}</td>
                      <td>{d.outstandingAmount}</td>
                      <td>{d.security}</td>
                      <td>{d.assetClassification}</td>
                      <td>{d.accountStatus}</td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          }
        </div>
      }
    </CardUI>
  )
}

export default CompanyCibilUI
